/** Small progressive enhancements that do not replace Shopify or app behaviour. */

function improveJudgeMeCarouselAccessibility() {
  const initialiseCarousel = (carousel) => {
    const wrapper = carousel.querySelector('.jdgm-cards-wrapper');
    if (!wrapper || wrapper.dataset.regearAccessibilityReady === 'true') return;
    wrapper.dataset.regearAccessibilityReady = 'true';

    const observedCards = new WeakSet();
    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!(entry.target instanceof HTMLElement)) return;
          entry.target.setAttribute('aria-hidden', entry.isIntersecting ? 'false' : 'true');
          entry.target.toggleAttribute('inert', !entry.isIntersecting);
        });
      },
      { root: wrapper, threshold: 0.05 }
    );

    const observeCards = () => {
      wrapper
        .querySelectorAll('.jdgm-card, .jdgm-review-card, [data-review-id], [class*="jdgm-card__"]')
        .forEach((card) => {
          if (!(card instanceof HTMLElement) || card === wrapper || card.contains(wrapper) || observedCards.has(card)) return;
          observedCards.add(card);
          visibilityObserver.observe(card);
        });
    };

    new MutationObserver(observeCards).observe(wrapper, { childList: true, subtree: true });
    observeCards();
  };

  const initialiseAll = () => document.querySelectorAll('.jdgm-cards-carousel').forEach(initialiseCarousel);
  new MutationObserver(initialiseAll).observe(document.body, { childList: true, subtree: true });
  initialiseAll();
}

function improveReviewImageDescriptions() {
  document.querySelectorAll('.jdgm-widget img[alt=""], .jdgm-widget img:not([alt])').forEach((image) => {
    image.alt = 'Customer review photo';
  });
}

function addMobileProductBar() {
  const productArea = document.querySelector('.product-information');
  const sourceButton = productArea?.querySelector('.add-to-cart-button:not([disabled])');
  if (!(productArea instanceof HTMLElement) || !(sourceButton instanceof HTMLButtonElement)) return;

  const title = productArea.querySelector('h1')?.textContent?.trim() || 'This item';
  const price = productArea.querySelector('.price')?.textContent?.replace(/\s+/g, ' ').trim() || '';
  const bar = document.createElement('div');
  bar.className = 'rg-mobile-product-bar';
  bar.hidden = true;
  bar.innerHTML = `
    <div class="rg-mobile-product-bar__details">
      <strong></strong>
      <span></span>
    </div>
    <button type="button" class="rg-mobile-product-bar__button">Add to cart</button>
  `;
  bar.querySelector('strong').textContent = title;
  bar.querySelector('span').textContent = price;
  const barButton = bar.querySelector('button');

  barButton.addEventListener('click', () => {
    const currentButton = productArea.querySelector('.add-to-cart-button:not([disabled])');
    if (currentButton instanceof HTMLButtonElement) currentButton.click();
  });

  const update = () => {
    const currentButton = productArea.querySelector('.add-to-cart-button');
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const passedOriginalButton = sourceButton.getBoundingClientRect().bottom < 0;
    const available = currentButton instanceof HTMLButtonElement && !currentButton.disabled;
    bar.hidden = !(mobile && passedOriginalButton && available);
    barButton.disabled = !available;
  };

  document.body.append(bar);
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  new MutationObserver(update).observe(productArea, { childList: true, subtree: true, attributes: true });
  update();
}

function initialiseStorefrontImprovements() {
  improveJudgeMeCarouselAccessibility();
  improveReviewImageDescriptions();
  addMobileProductBar();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseStorefrontImprovements, { once: true });
} else {
  initialiseStorefrontImprovements();
}
